import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {Subscription} from "rxjs";
import * as angular from "angular";
import {RouteModel} from "../../../../routes/models/route.model";
import {RouteAssistantAssignmentStore} from "./route-assistant-assignment.store";
import {AgentModel} from "../../../../agents/angular/models/agent.model";
import * as _ from "lodash";

require('./route-assistant-assignment.scss');
@Component({
  standalone: false,
  selector: 'app-route-assistant-assignment',
  templateUrl: './route-assistant-assignment.html',
  providers: [RouteAssistantAssignmentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouteAssistantAssignmentComponent implements OnInit, OnDestroy {

  @Input() routeIds: string[];
  @Input() selectedIds?: string[];
  @Input() excludeIds?: string[];
  @Output() onAssign = new EventEmitter<string[]>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public queryString: string = '';
  public loadLimit: number = 20;

  public assistants: AgentModel[] = [];
  public selectedKeys: {[id: string]: boolean} = {};
  public excludeKeys: {[id: string]: boolean} = {};

  public cursor: string;
  public isLoading: boolean;

  private assistantsSubscription: Subscription;

  constructor(
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject(RouteAssistantAssignmentStore) private store: RouteAssistantAssignmentStore
  ) {}

  ngOnInit() {

    this.assistantsSubscription = this.store.vm$.subscribe((vm) => {
      this.cursor = vm.cursor;
      this.isLoading = vm.loading;
      this.assistants = vm.assistants;

      this.cdr.detectChanges();
      setTimeout(() => {
        this.cdkVirtualScrollViewport?.checkViewportSize();
      });
    });

    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });

    this.excludeKeys = {};
    _.forEach(this.excludeIds, (id) => {
      this.excludeKeys[id] = true;
    })

    this._getAssistants();
  }

  ngOnDestroy() {
    if (this.assistantsSubscription) {
      this.assistantsSubscription.unsubscribe();
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 150 && this.cursor && !this.isLoading) {
      this._getAssistants();
    }
  }

  onSelect(agent) {
    this.selectedKeys[agent.id] = !this.selectedKeys[agent.id];
    this.selectedIds = Object.keys(this.selectedKeys).filter(id => this.selectedKeys[id]);
  }

  onAssignAssistant() {
    this.onAssign.emit(this.selectedIds);
  }

  onQueryChange(query) {
    this.queryString = query;
    // Client-side filtering because the endpoint doesn't seem to take `query` yet,
    // or if we needed to reset we would call:
    this.store.resetAssistants();
    this._getAssistants();
    this.cdr.detectChanges();
  }

  onToggleAssistant(agent: AgentModel) {
    this.selectedKeys[agent.id] = !this.selectedKeys[agent.id];
  }

  private _getAssistants() {
    this.store.getAssistants({
      // routeIds: this.routeIds,
      query: this.queryString,
      limit: this.loadLimit
    });
  }
}
